import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class CategoryService {
  async getAllCategories(params) {
    let queryParams = "";
    let join = "";

    Object.keys(params).forEach(param => {
      if (param) {
        if (param == "search")
          queryParams += join + `${param}=${encodeURIComponent(params[param])}`;
        else
          queryParams += join + `${param}=${params[param]}`;
        join = "&";
      }
    });

    return (
      await fetchApi.get(
        `${URL}/category/list${queryParams ? "?" + queryParams : ""}`
      )
    ).data;
  }

  async getCategoryById(id) {
    return (await fetchApi.get(`${URL}/category/${id}`)).data;
  }

  async createCategory(formData) {
    return (await fetchApi.post(`${URL}/category`, formData)).data;
  }

  async updateCategory(id, formData) {
    return (await fetchApi.patch(`${URL}/category/${id}`, formData)).data;
  }

  async deleteCategory(id) {
    return (await fetchApi.delete(`${URL}/category/${id}`)).data;
  }

  async getSubcategoriesByCategoryId(id) {
    return (await fetchApi.get(`${URL}/category/${id}/subcategories`)).data;
  }
}
